<template>

    <DashboardContainer>

        <DashboardTab
                :tabs="tabs"
                :selected-tab="selectedTab"
                @select="changeTab"
        />

        <ListSmsConfigs
                v-if="selectedTab===0"
                @update="handleUpdate"
        />

        <CreateSmsConfig
                v-if="selectedTab===1"
                :config="config"
        />

    </DashboardContainer>

</template>

<script>

import DashboardContainer from "@/dashboard/containers/DashboardContainer.vue";
import DashboardTab from "@/dashboard/tab/DashboardTab.vue";

import CreateSmsConfig from "@/dashboard/sms/CreateSmsConfig.vue";
import ListSmsConfigs from "@/dashboard/sms/ListSmsConfigs.vue";

export default {

    name: "SmsConfigBoard",

    components: {
        DashboardContainer,
        DashboardTab,
        CreateSmsConfig,
        ListSmsConfigs
    },

    data(){
        return{
            selectedTab : 0,

            tabs : [
                'List',
                'Create'
            ],

            config : {
                id : null,

                institutionId : null,

                token : '',

                senderId : '',

                peId : '',

                dcs : 0,

                flashSms : 0,

                active : true
            }
        }
    },

    methods : {

        changeTab(tabIndex){
            this.selectedTab = tabIndex;
        },

        handleUpdate(config){
            this.config = {...config};
            this.selectedTab = 1;
        }

    }

}

</script>

<style scoped lang="scss">

</style>